/* eslint-disable */
var $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import draggable from "vuedraggable";
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'quiz',
  components: {
    draggable
  },
  props: [],
  data() {
    return {
      QuizListDetails: null,
      removeQuizId: '',
      addquiz: null,
      isActive: false,
      is_active: false,
      pub_catID: '',
      isVisible: false,
      is_visible: false,
    }
  },
  computed: {
    ...mapGetters([
      'getContestQuizDataState',
      'getQuizDetailsByIdDataState'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    geQuizList() {
      this.$store.dispatch('getContestQuizByCategoryFun', {
        id: this.$route.params.quiz_catId
      }).then((res) => {
        this.QuizListDetails = this.$store.getters.getContestQuizDataState.data
      }).catch((err) => {})
    },
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
      this.geQuizList
  },
  methods: {
    geQuizListAgain() {
      this.$store.dispatch('getContestQuizByCategoryFun', {
        id: this.$route.params.quiz_catId
      }).then((res) => {
        this.QuizListDetails = this.$store.getters.getContestQuizDataState.data
      }).catch((err) => {})
    },
    courseQuizStatusAct(quizId) {
      let data = {
        id: quizId
      }
      this.$store.dispatch('getQuizDetailsByIdFun', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.isActive = this.$store.getters.getQuizDetailsByIdDataState.is_active
            if (this.isActive === true) {
              this.is_active = false
            }
            if (this.isActive === false) {
              this.is_active = true
            }
            let data = {
              is_active: this.is_active,
            }
            this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.geQuizListAgain();
                toast.success("Quiz Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    courseIsvisibleStatusAct(quizId) {
      let data = {
        id: quizId
      }
      this.$store.dispatch('getQuizDetailsByIdFun', data)
        .then((res) => {
          if (res.data.code == '2000') {
            this.isVisible = this.$store.getters.getQuizDetailsByIdDataState.is_visible
            if (this.isVisible === true) {
              this.is_visible = false
            }
            if (this.isVisible === false) {
              this.is_visible = true
            }
            let data = {
              is_visible: this.is_visible,
            }
            this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                this.geQuizListAgain();
                toast.success("Quiz Status Updated Successfully");
              }
            }).catch((err) => {})
            return
          }
        }).catch((err) => {})
    },
    removeQuizagain(id) {
      $('#removQuizModalAgain').modal();
      this.removeQuizId = id
    },
    RemoveQuizConfirmationagain() {
      this.$store.dispatch('removeQuizFun', {
        id: this.removeQuizId
      }).then((res) => {
        this.geQuizListAgain()
      }).catch((err) => {})
    }
  },
  beforeMount() {},
  watch: {}
}